import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// Match playground's cn — teach twMerge about the `snplay:` prefix so
// classes like `snplay:bg-left` correctly override `snplay:bg-center`
// baked into a base component's cn(...) call. Without this, plain
// twMerge treats each `snplay:*` token as unknown and keeps both,
// leaving the outcome up to CSS declaration order.
const twMerge = extendTailwindMerge({ prefix: 'snplay' })

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
